<template>
  <span :class="isActiveClassName">
    <img
      src="../../assets/vmarket_4th_bg.png"
      alt="『バーチャルマーケット4』"
      :class="backClassName(3)"
    />
    <img
      src="../../assets/vmarket_4th_bg.png"
      alt="『バーチャルマーケット4』"
      :class="backClassName(0)"
    />
    <img
      src="../../assets/vmarket_4th_bg.png"
      alt="『バーチャルマーケット4』"
      :class="backClassName(2)"
    />
    <img
      src="../../assets/vmarket_4th_bg.png"
      alt="『バーチャルマーケット4』"
      :class="backClassName(1)"
    />
    <img
      src="../../assets/vmarket_4th_front.png"
      alt="『バーチャルマーケット4』"
      :class="frontClassName(3)"
    />
    <img
      src="../../assets/vmarket_4th_front.png"
      alt="『バーチャルマーケット4』"
      :class="frontClassName(0)"
    />
    <img
      src="../../assets/vmarket_4th_front.png"
      alt="『バーチャルマーケット4』"
      :class="frontClassName(2)"
    />
    <img
      src="../../assets/vmarket_4th_front.png"
      alt="『バーチャルマーケット4』"
      :class="frontClassName(1)"
    />
  </span>
</template>

<script>
export default {
  name: "Vmarket4th",
  props: {
    isActive: Boolean
  },
  data() {
    return {
      delay: 1000
    };
  },
  computed: {
    frontClassName: function() {
      return function(_num) {
        return "vmarket_4th_front rand" + _num;
      };
    },
    backClassName: function() {
      return function(_num) {
        return "vmarket_4th_bg rand" + _num;
      };
    },
    isActiveClassName: function() {
      return this.isActive ? "vmarket_4th active" : "vmarket_4th";
    }
  }
};
</script>

<style scoped>
.vmarket_4th {
  width: 100%;
  padding: 38% 0 0;
}
.vmarket_4th_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.vmarket_4th_bg:nth-of-type(1) {
  mask-image: linear-gradient(to bottom, black 0% 25%, transparent 25%);
}
.vmarket_4th_bg:nth-of-type(2) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 25% 35%);
}
.vmarket_4th_bg:nth-of-type(3) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 35% 65%);
}
.vmarket_4th_bg:nth-of-type(4) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 65%);
}
.vmarket_4th_front {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.vmarket_4th_front:nth-of-type(5) {
  mask-image: linear-gradient(to bottom, black 0% 25%, transparent 25%);
}
.vmarket_4th_front:nth-of-type(6) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 25% 35%);
}
.vmarket_4th_front:nth-of-type(7) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 35% 65%);
}
.vmarket_4th_front:nth-of-type(8) {
  mask-image: linear-gradient(to bottom, transparent 0% 25%, black 65%);
}
.active .rand0 {
  animation: glitch 0.12s ease-in-out 0s forwards;
}
.active .rand1 {
  animation: glitch 0.12s ease-in-out 0.04s forwards;
}
.active .rand2 {
  animation: glitch 0.12s ease-in-out 0.08s forwards;
}
.active .rand3 {
  animation: glitch 0.12s ease-in-out 0.1s forwards;
}
@keyframes glitch {
  from,
  to {
    transform: translateX(0);
  }
  40% {
    transform: translateX(5%);
  }
  80% {
    transform: translateX(-5%);
  }
}

@media screen and (max-width: 578px) {
  .vmarket_4th {
    width: 100%;
    position: relative;
    margin: 0 auto;
    padding-top: 39%;
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/TheVmarket4th.vue